//const PROVISIONAL_YEAR = 2021;

const flowMapper = {
  AGRICULT: "Agriculture/forestry",
  BUILDINGS: "Buildings",
  CO2ELEC: "CO2 emissions from electricity generation",
  CO2ELECK: "CO2 emissions from electricity generation",
  CO2FUELK: "CO2 emissions",
  CO2GDP: "CO2 emissions per unit of GDP",
  CO2GDPPP: "CO2 emissions per unit of GDP (PPP)",
  CO2INTMIX: "CO2 intensity of fossil fuel mix",
  CO2INTMIXK: "CO2 intensity of fossil fuel mix",
  CO2POP: "CO2 emissions per population",
  CO2TES: "CO2 emissions per total energy supply",
  COMMPUB: "Commercial and public services",
  ELECHEAT: "Electricity and heat generation",
  ELOUTPUT: "Electricity output",
  ELOUTPUTK: "Electricity output",
  FISHING: "Fishing",
  FOSSILELE: "Fossil share in electricity",
  FOSSILELEK: "Fossil share in electricity",
  GHGENERGY: "Total GHG emissions - Energy",
  GHGFUEL: "Total GHG emissions - Fuel combustion",
  GHGFUGITI: "Total GHG emissions - Fugitive",
  ICO2EMIS: "CO2 emissions",
  ICO2TES: "Carbon intensity",
  ICO2TESK: "Carbon intensity",
  IGDPPOP: "GDP PPP per population",
  IGDPPOPK: "GDP PPP per population",
  IPOP: "Population",
  IPOPK: "Population",
  ITESGDP: "Energy intensity",
  ITESGDPK: "Energy intensity",
  MAGRICALC: "Memo: Agriculture/forestry with ele and heat reallocated",
  MBUILDINGS: "Buildings",
  MCOPUBALC:
    "Memo: Commercial and public services with ele and heat reallocated",
  MFISHALC: "Memo: Fishing with ele and heat reallocated",
  MINDUSALC: "Industry",
  MONONSPALC:
    "Memo: Final consumption not elsewhere specified with ele and heat reallocated",
  MOTHERS: "Others",
  MRESIDALC: "Memo: Residential with ele and heat reallocated",
  MTRANSALC: "Transport",
  ONONSPEC: "Final consumption not elsewhere specified",
  OTHERS: "Others",
  RESIDENT: "Residential",
  SHAREFC: "Share of GHG emissions from fuel combustion",
  SHAREFUGI: "Share of fugitive GHG emissions",
  TES: "Total energy supply",
  THERMELEC: "Thermal efficiency of electricity plants",
  THERMELECK: "Thermal efficiency of electricity plants",
  TOTIND: "Industry",
  TOTTRANS: "Transport",
};

// Try to accept "2001" but not "2001-2010"
function isReallyInt(value) {
  return (
    typeof value === "number" ||
    (Number.isInteger(parseInt(value)) &&
      parseInt(value).toString().length === value.length)
  );
}

function formatFlows(data) {
  return [...data].map((row) => {
    return {
      ...row,
      FLOW: row.CODE_FLOW in flowMapper ? flowMapper[row.CODE_FLOW] : row.FLOW,
    };
  });
}

function orderProducts(data) {
  return data.sort((a, b) => {
    const order = [
      "Coal, peat and oil shale",
      "Natural gas",
      "Oil",
      "Biofuels and waste",
      "Nuclear",
      "Other",
    ];
    return order.indexOf(a["PRODUCT"]) - order.indexOf(b["PRODUCT"]);
  });
}

function sliceData(data, xAxisDimension, yAxisDimension, valueDimension) {
  const colorIndexProduct = {
    "Coal, peat and oil shale": 0,
    "Natural gas": 1,
    Oil: 2,
    "Biofuels and waste": 3,
    Nuclear: 4,
    Other: 5,
  };

  // Extract unique categories from filtered data set
  const categories = data.reduce(
    (categories, dataRow) => {
      if (!categories.x.includes(dataRow[xAxisDimension]))
        categories.x.push(dataRow[xAxisDimension]);
      if (!categories.y.includes(dataRow[yAxisDimension]))
        categories.y.push(dataRow[yAxisDimension]);
      return categories;
    },
    { x: [], y: [] }
  );

  const xIsNumeric = categories.x.every((xCategory) =>
    Number.isInteger(parseInt(xCategory))
  );
  // ensure numeric X axis is sorted
  if (xIsNumeric) categories.x.sort();

  const slicedData = categories.y.map((seriesName) => ({
    name: seriesName,
    colorIndex: colorIndexProduct[seriesName],
    data: categories.x.map((xCategory) => {
      const rowData = data.find(
        (dataRow) =>
          dataRow[xAxisDimension] === xCategory &&
          dataRow[yAxisDimension] === seriesName
      );
      // Handle cases where x/y combo doesn't exist in data
      const rawValue = rowData ? rowData[valueDimension] : null;
      let finalValue = rawValue;
      finalValue = Number.isNaN(parseFloat(finalValue))
        ? null
        : parseFloat(finalValue);
      return [
        isReallyInt(xCategory) ? parseInt(xCategory) : xCategory,
        finalValue,
      ];
    }),
  }));

  return {
    slicedData,
    xAxisCategories: categories.x,
  };
}

function sliceDriversData(
  data,
  xAxisDimension,
  yAxisDimension,
  _valueDimension,
  codeFlow,
  type = "scatter"
) {
  if (!data || data.length === 0) {
    return [];
  }

  // Extract unique categories from filtered data set
  const categories = data.reduce(
    (categories, dataRow) => {
      if (!categories.x.includes(dataRow[xAxisDimension]))
        categories.x.push(dataRow[xAxisDimension]);
      if (!categories.y.includes(dataRow[yAxisDimension]))
        categories.y.push(dataRow[yAxisDimension]);
      return categories;
    },
    { x: [], y: [] }
  );
  categories.y = [...categories.y].sort();

  if (type === "scatter") {
    categories.x = ["2000-2010", "2010-2022", "2000-2022"];
  }

  const codeFlowMapper = data.reduce((mapper, dataRow) => {
    if (!mapper[dataRow.CODE_FLOW]) {
      mapper[dataRow.CODE_FLOW] = dataRow.FLOW;
    }
    return mapper;
  }, {});

  const slicedData = categories.y.map((seriesName) => {
    let series = {
      name: seriesName,
      data: categories.x.map((xCategory) => {
        const rowData = data.find(
          (dataRow) =>
            dataRow[xAxisDimension] === xCategory &&
            dataRow[yAxisDimension] === seriesName
        );
        // Handle cases where x/y combo doesn't exist in data
        const rawValue = rowData ? rowData.VALUE : null;
        let finalValue = rawValue;
        finalValue = Number.isNaN(parseFloat(finalValue))
          ? null
          : parseFloat(finalValue);
        return [
          isReallyInt(xCategory) ? parseInt(xCategory) : xCategory,
          finalValue,
        ];
      }),
    };

    if (codeFlowMapper[codeFlow] && codeFlowMapper[codeFlow] === seriesName) {
      if (type === "scatter") {
        series = {
          ...series,
          type: "scatter",
          marker: {
            enabled: true,
          },
          tooltip: {
            valueDecimals: 1,
            headerFormat: `<span class='highcharts-header'>{point.x}</span><br>`,
            pointFormat: `<span class='highcharts-color-{series.colorIndex}'>●</span> {series.name} change: <b>{point.y}</b>`,
          },

          zIndex: 99,
        };
      } else if (type === "line") {
        series = {
          ...series,
          className: "highcharts-stroke-bold",
        };
      }
    }
    return series;
  });

  return {
    slicedData,
    xAxisCategories: categories.x,
  };
}

const countryParam = (apiRoute) => ({
  id: "COUNTRY",
  name: "Country",
  url: `${apiRoute}/list/COUNTRY`,
  type: "select",
});
const yearParam = (apiRoute) => ({
  id: "TIME",
  name: "Year",
  url: `${apiRoute}/list/TIME`,
  staticParams: {
    CODE_FLOW: "GHGFUEL",
  },
  type: "select",
});

const parameterValues = {
  COUNTRY: "World",
  TIME: "2022",
  CODE_FLOW: "CO2GDP",
};

function yearTickPositioner() {
  const positions = [];
  const increment = 5;
  if (this.dataMax !== null && this.dataMin !== null) {
    positions.push(this.dataMin);
    for (
      let tick = Math.floor(this.dataMin / 10) * 10 + increment;
      tick <= this.dataMax - increment;
      tick += increment
    ) {
      positions.push(tick);
    }
    positions.push(this.dataMax);
  }
  return positions;
}

const highlightsExplorerData = (apiRoute) => ({
  parameters: [
    {
      ...countryParam(apiRoute),
      staticParams: {
        CODE_FLOW: "GHGFUEL",
      },
    },
  ],
  parameterValues: { ...parameterValues },
  indicators: [
    {
      type: "box",
      url: apiRoute,
      params: ["COUNTRY", "TIME", "CODE_PRODUCT", "CODE_FLOW"],
      staticParams: {
        CODE_PRODUCT: "TOTAL",
        CODE_FLOW: ["GHGFUEL", "CO2TES", "CO2GDPPP", "CO2POP"],
      },
      extraParams: [yearParam(apiRoute)],
      config: {
        title: (paramValues) => {
          return `Key emissions figures for ${paramValues.TIME}, ${paramValues.COUNTRY}`;
        },
        indicators: (_paramValues, data) => {
          const unitMapping = {
            GHGFUEL: "MtCO2eq",
            CO2TES: "tCO2/TJ",
            CO2GDPPP: "kgCO2/2015 USD",
            CO2POP: "tCO2/capita",
          };
          const indicators = {
            [`${flowMapper["GHGFUEL"]}|(${unitMapping["GHGFUEL"]})`]: "--",
            [`${flowMapper["CO2TES"]}|(${unitMapping["CO2TES"]})`]: "--",
            [`${flowMapper["CO2GDPPP"]}|(${unitMapping["CO2GDPPP"]})`]: "--",
            [`${flowMapper["CO2POP"]}|(${unitMapping["CO2POP"]})`]: "--",
          };
          if (!data) {
            return indicators;
          }
          data.forEach((row) => {
            if (row.VALUE) {
              indicators[
                `${flowMapper[row.CODE_FLOW]}|(${unitMapping[row.CODE_FLOW]})`
              ] = (Math.round(row.VALUE * 10) / 10)
                .toLocaleString("FR")
                .replace(",", ".");
            }
          });
          return indicators;
        },
      },
    },
    {
      url: apiRoute,
      params: ["COUNTRY", "CODE_PRODUCT", "CODE_FLOW"],
      staticParams: {
        CODE_PRODUCT: ["COAL", "WASTEBIO", "GAS", "OIL"],
        CODE_FLOW: "GHGFUEL",
      },
      type: "chart",
      config: {
        title: (paramValues) => {
          return `Total GHG emissions from fuel combustion per product, ${paramValues.COUNTRY}`;
        },
        unit: "MtCO2eq",
        chartType: "area",
        xAxisDimension: "TIME",
        yAxisDimension: "PRODUCT",
        valueDimension: "VALUE",
        customSlicer: sliceData,
        dataFormatter: orderProducts,
        chartOptions: {
          chart: {
            marginRight: 0,
          },
          tooltip: {
            shared: true,
          },
          xAxis: {
            type: "numeric",
            tickPositioner: yearTickPositioner,
            /*
            plotBands: [
              {
                from: PROVISIONAL_YEAR,
                to: PROVISIONAL_YEAR + 1,
                label: { text: 'Provisional', align: 'center', rotation: -90 },
              },
            ],
            */
          },
        },
      },
    },
    {
      url: apiRoute,
      params: ["COUNTRY", "TIME", "CODE_PRODUCT", "CODE_FLOW"],
      staticParams: {
        CODE_PRODUCT: [
          "MTOTSOLID",
          "COMRENEW",
          "NATGAS",
          "MTOTOIL",
          "NUCLEAR",
          "RENE",
          "COAL",
          "GAS",
          "OIL",
          "WASTEBIO",
        ],
        CODE_FLOW: ["TES", "GHGFUEL"],
      },
      extraParams: [yearParam(apiRoute)],
      type: "chart",
      notes:
        "Other is an aggregation which includes other renewables, e.g. hydro, geothermal, solar and wind.",
      config: {
        title: (paramValues) => {
          return `Share of GHG emissions and total energy supply by product, ${paramValues.COUNTRY}, ${paramValues.TIME}`;
        },
        noSingleValue: true,
        unit: "%",
        chartType: "bar",
        xAxisDimension: "FLOW",
        yAxisDimension: "PRODUCT",
        valueDimension: "VALUE",
        dataFormatter: (data) => {
          return orderProducts(data)
            .map((row) => ({
              ...row,
              FLOW: row.FLOW.includes("Total GHG emissions")
                ? "GHG emissions"
                : row.FLOW,
            }))
            .sort((a, b) =>
              a.FLOW === "GHG emissions"
                ? b.FLOW === "GHG emissions"
                  ? 0
                  : -1
                : 1
            );
        },
        customSlicer: sliceData,
        chartOptions: {
          plotOptions: {
            bar: {
              stacking: "percent",
            },
          },
          tooltip: {
            formatter: function (tooltip) {
              const defaultTooltip = tooltip.defaultFormatter.call(
                this,
                tooltip
              );
              defaultTooltip[1] = defaultTooltip[1].replace(
                /(.*<b>).*(&nbsp;%.*)/,
                `$1${Math.round(this.percentage * 10) / 10}$2`
              );
              return defaultTooltip;
            },
          },
        },
      },
    },
  ],
});

const fugitiveEmissionsExplorerData = (apiRoute) => ({
  parameters: [
    {
      ...countryParam(apiRoute),
      staticParams: {
        CODE_FLOW: "GHGFUGITI",
      },
    },
  ],
  parameterValues: { ...parameterValues },
  indicators: [
    {
      url: apiRoute,
      params: ["COUNTRY", "CODE_PRODUCT", "CODE_FLOW"],
      staticParams: {
        CODE_PRODUCT: ["COAL", "OIL", "GAS", "COMRENEW"],
        CODE_FLOW: "GHGENERGY",
      },
      type: "chart",
      config: {
        title: (paramValues) => {
          return `Total GHG emissions from energy per product, ${paramValues.COUNTRY}`;
        },
        unit: "MtCO2eq",
        chartType: "area",
        xAxisDimension: "TIME",
        yAxisDimension: "PRODUCT",
        valueDimension: "VALUE",
        customSlicer: sliceData,
        dataFormatter: orderProducts,
        chartOptions: {
          tooltip: {
            shared: true,
          },
          xAxis: {
            type: "numeric",
            tickPositioner: yearTickPositioner,
          },
        },
      },
    },
    {
      url: `${apiRoute}`,
      params: ["CODE_FLOW", "TIME", "COUNTRY"],
      type: "chart",
      staticParams: (paramValues) => {
        const params = {
          CODE_FLOW: ["SHAREFC", "SHAREFUGI"],
          COUNTRY: [
            "World",
            "People's Republic of China",
            "Russian Federation",
            "United States",
            "United Arab Emirates",
            "Iraq",
            "Turkmenistan",
            "Iran",
            "Algeria",
            "Bolivarian Republic of Venezuela",
            "Canada",
            "Australia",
            "European Union",
          ],
        };

        if (!params.COUNTRY.includes(paramValues.COUNTRY)) {
          params.COUNTRY.push(paramValues.COUNTRY);
        }
        return params;
      },
      extraParams: [
        {
          ...yearParam(apiRoute),
          staticParams: {
            CODE_FLOW: "SHAREFUGI",
          },
        },
      ],
      config: {
        title: (paramValues) =>
          `Share of fuel combustion and fugitive GHG emissions, ${paramValues.TIME}`,
        unit: "%",
        chartType: "bar",
        xAxisDimension: "COUNTRY",
        yAxisDimension: "FLOW",
        valueDimension: "VALUE",
        noXNumeric: true,
        dataFormatter: (data) => {
          const formattedData = [...data]
            .filter((row) => row.VALUE !== "..")
            .sort((a, b) => {
              if (a.CODE_FLOW < b.CODE_FLOW) {
                return -1;
              } else if (a.CODE_FLOW > b.CODE_FLOW) {
                return 1;
              } else {
                return parseFloat(a.VALUE) - parseFloat(b.VALUE);
              }
            })
            .map((row) => {
              return {
                ...row,
                FLOW: row.FLOW.replace("(%)", ""),
              };
            });
          return formattedData;
        },
        chartOptions: (paramValues) => ({
          // chart: {
          //   height: 1800,
          // },
          plotOptions: {
            series: {
              stacking: "normal",
            },
          },
          xAxis: {
            labels: {
              formatter: (data) => {
                if (paramValues.COUNTRY === data.value) {
                  return `<b>${data.value}</b>`;
                }
                return data.value;
              },
            },
          },
          yAxis: {
            endOnTick: false,
            max: 100,
          },
          tooltip: {
            shared: true,
          },
        }),
      },
    },
  ],
});

const socioeconomicIndicatorsExplorerData = (apiRoute) => ({
  parameters: [
    {
      ...countryParam(apiRoute),
      staticParams: {
        CODE_FLOW: "CO2GDP",
      },
    },
  ],
  parameterValues: { ...parameterValues },
  indicators: [
    {
      url: apiRoute,
      params: ["COUNTRY", "CODE_PRODUCT", "CODE_FLOW"],
      staticParams: {
        CODE_PRODUCT: "TOTAL",
      },
      type: "chart",
      extraParams: [
        {
          id: "CODE_FLOW",
          name: "Flow",
          options: [
            {
              label: flowMapper["CO2GDP"],
              value: "CO2GDP",
            },
            {
              label: flowMapper["CO2GDPPP"],
              value: "CO2GDPPP",
            },
            {
              label: flowMapper["CO2POP"],
              value: "CO2POP",
            },
          ],
          type: "select",
        },
      ],
      config: {
        title: (paramValues) =>
          `${flowMapper[paramValues.CODE_FLOW]}, ${paramValues.COUNTRY}`,
        unit: (paramValues) => {
          if (paramValues.CODE_FLOW === "CO2GDP") {
            return "kgCO2/2015 USD";
          }
          if (paramValues.CODE_FLOW === "CO2GDPPP") {
            return "kgCO2/2015 USD";
          }
          if (paramValues.CODE_FLOW === "CO2POP") {
            return "tCO2/capita";
          }
        },
        legendDisabled: false,
        chartType: "line",
        xAxisDimension: "TIME",
        yAxisDimension: "CODE_FLOW",
        valueDimension: "VALUE",
        dataFormatter: (data) => {
          return [...data].map((row) => {
            return {
              ...row,
              CODE_FLOW: flowMapper[row.CODE_FLOW],
            };
          });
        },
        chartOptions: {
          yAxis: {
            min: 0,
          },
          tooltip: {
            valueDecimals: 2,
          },
          xAxis: {
            type: "numeric",
            tickPositioner: yearTickPositioner,
          },
        },
      },
    },
    {
      url: apiRoute,
      size: 2,
      params: ["COUNTRY", "CODE_PRODUCT", "CODE_FLOW"],
      staticParams: {
        CODE_PRODUCT: "TOTAL",
        CODE_FLOW: ["IPOP", "IGDPPOP", "ITESGDP", "ICO2TES", "ICO2EMIS"],
        TIME: "2000+",
      },
      type: "chart",
      config: {
        title: (paramValues) => {
          return `CO2 emissions drivers from fuel combustion, index, ${paramValues.COUNTRY}`;
        },
        unit: "(2000=100)",
        chartType: "line",
        xAxisDimension: "TIME",
        yAxisDimension: "FLOW",
        valueDimension: "VALUE",
        dataFormatter: (data) => {
          const formattedData = formatFlows(data);
          return formattedData.filter(
            (row) => !(row.CODE_TIME === "2021E" && row.COUNTRY === "World")
          );
        },
        customSlicer: (data, xAxisDimension, yAxisDimension, valueDimension) =>
          sliceDriversData(
            data,
            xAxisDimension,
            yAxisDimension,
            valueDimension,
            "ICO2EMIS",
            "line"
          ),
        chartOptions: {
          yAxis: {
            plotLines: [
              {
                className: "highcharts-zero-axis",
                value: 100,
                zIndex: 1,
              },
            ],
          },
          xAxis: {
            type: "numeric",
            tickPositioner: yearTickPositioner,
          },
        },
      },
    },
    {
      url: apiRoute,
      size: 2,
      params: ["COUNTRY", "CODE_PRODUCT", "CODE_FLOW"],
      staticParams: {
        CODE_PRODUCT: "TOTAL",
        CODE_FLOW: ["CO2FUELK", "IPOPK", "IGDPPOPK", "ITESGDPK", "ICO2TESK"],
      },
      type: "chart",
      config: {
        title: (paramValues) => {
          return `CO2 emissions drivers from fuel combustion, annual average change, ${paramValues.COUNTRY}`;
        },
        unit: "ktCO2",
        chartType: "column",
        xAxisDimension: "CODE_TIME",
        yAxisDimension: "FLOW",
        valueDimension: "VALUE",
        noXNumeric: true,
        dataFormatter: (data) => formatFlows(data),
        customSlicer: (data, xAxisDimension, yAxisDimension, valueDimension) =>
          sliceDriversData(
            data,
            xAxisDimension,
            yAxisDimension,
            valueDimension,
            "CO2FUELK"
          ),
        chartOptions: {
          yAxis: {
            plotLines: [
              {
                className: "highcharts-zero-axis",
                value: 0,
                zIndex: 1,
              },
            ],
          },
        },
      },
    },
  ],
});

const sectoralAnalysisExplorerData = (apiRoute) => ({
  parameters: [
    {
      ...countryParam(apiRoute),
      staticParams: {
        CODE_FLOW: "ELECHEAT",
      },
    },
  ],
  parameterValues: { ...parameterValues, separated: true },
  indicators: [
    {
      url: apiRoute,
      params: ["COUNTRY", "CODE_PRODUCT", "CODE_FLOW"],
      staticParams: (paramValues) => {
        const staticParams = {
          CODE_PRODUCT: "TOTAL",
          CODE_TIME: ["1990", "2000", "2010", "2022"],
        };
        if (paramValues.separated) {
          staticParams.CODE_FLOW = [
            "ELECHEAT",
            "TOTTRANS",
            "TOTIND",
            "BUILDINGS",
            "OTHERS",
          ];
        } else {
          staticParams.CODE_FLOW = [
            "MTRANSALC",
            "MINDUSALC",
            "MBUILDINGS",
            "MOTHERS",
          ];
        }
        return staticParams;
      },
      type: "chart",
      notes:
        "Others includes emissions from agriculture and forestry, fishing, other energy industry own use, and other final consumption not elsewhere specified.",
      extraParams: [
        {
          id: "separated",
          type: "buttonGroup",
          options: [
            {
              label: "Separated",
              value: true,
            },
            {
              label: "Reallocated",
              value: false,
            },
          ],
        },
      ],
      config: {
        title: (paramValues) =>
          `Global CO2 emissions from fuel combustion by sector with electricity and heat ${
            paramValues.separated ? "separated" : "reallocated"
          }, ${paramValues.COUNTRY}`,
        unit: "ktCO2",
        chartType: "column",
        xAxisDimension: "TIME",
        yAxisDimension: "FLOW",
        valueDimension: "VALUE",
        noXNumeric: true,
        dataFormatter: (data) => {
          const formatted = formatFlows(data);

          return [...formatted]
            .map((rowData) => ({ ...rowData, TIME: parseInt(rowData.TIME) }))
            .sort((a, b) => {
              if (a.FLOW.includes("Electricity")) {
                return 1;
              }
              if (b.FLOW.includes("Electricity")) {
                return -1;
              }
              if (a.FLOW < b.FLOW) {
                return -1;
              }
              if (a.FLOW > b.FLOW) {
                return 1;
              }
              return 0;
            });
        },
        chartOptions: {
          xAxis: {
            type: "numeric",
            tickPositions: [1990, 2000, 2010, 2022],
          },
        },
      },
    },
  ],
});

const powerGenerationExplorerData = (apiRoute) => ({
  parameters: [
    {
      ...countryParam(apiRoute),
      staticParams: {
        CODE_FLOW: "ELECHEAT",
      },
    },
  ],
  parameterValues: { ...parameterValues },
  indicators: [
    {
      url: apiRoute,
      params: ["COUNTRY", "CODE_PRODUCT", "CODE_FLOW"],
      staticParams: {
        CODE_PRODUCT: ["COAL", "OIL", "GAS", "OTHER"],
        CODE_FLOW: "ELECHEAT",
        CODE_TIME: ["1990", "2000", "2010", "2022"],
      },
      type: "chart",
      config: {
        title: (paramValues) => {
          return `CO2 emissions from electricity and heat generation by energy source, ${paramValues.COUNTRY}`;
        },
        unit: "MtCO2",
        chartType: "column",
        xAxisDimension: "TIME",
        yAxisDimension: "PRODUCT",
        valueDimension: "VALUE",
        noXNumeric: true,
        customSlicer: sliceData,
        dataFormatter: orderProducts,
        chartOptions: {
          xAxis: {
            type: "numeric",
            tickPositions: [1990, 2000, 2010, 2022],
          },
        },
      },
    },
    {
      url: `${apiRoute}`,
      size: 2,
      params: ["COUNTRY", "CODE_PRODUCT", "CODE_FLOW"],
      staticParams: {
        CODE_FLOW: [
          "ELOUTPUT",
          "FOSSILELE",
          "CO2INTMIX",
          "THERMELEC",
          "CO2ELEC",
        ],
        TIME: "2000+",
      },
      type: "chart",
      config: {
        title: (paramValues) => {
          return `Electricity generation and CO2 emissions drivers, index, ${paramValues.COUNTRY}`;
        },
        unit: "(2000=100)",
        chartType: "line",
        xAxisDimension: "TIME",
        yAxisDimension: "FLOW",
        valueDimension: "VALUE",
        dataFormatter: (data) => formatFlows(data),
        customSlicer: (data, xAxisDimension, yAxisDimension, valueDimension) =>
          sliceDriversData(
            data,
            xAxisDimension,
            yAxisDimension,
            valueDimension,
            "CO2ELEC",
            "line"
          ),
        chartOptions: {
          yAxis: {
            plotLines: [
              {
                className: "highcharts-zero-axis",
                value: 100,
                zIndex: 1,
              },
            ],
          },
        },
      },
    },
    {
      url: apiRoute,
      size: 2,
      params: ["COUNTRY", "CODE_PRODUCT", "CODE_FLOW"],
      staticParams: {
        CODE_PRODUCT: "TOTAL",
        CODE_FLOW: [
          "ELOUTPUTK",
          "FOSSILELEK",
          "CO2INTMIXK",
          "THERMELECK",
          "CO2ELECK",
        ],
      },
      type: "chart",
      config: {
        title: (paramValues) => {
          return `Electricity generation and CO2 emissions drivers, annual average change, ${paramValues.COUNTRY}`;
        },
        unit: "ktCO2",
        chartType: "column",
        xAxisDimension: "CODE_TIME",
        yAxisDimension: "FLOW",
        valueDimension: "VALUE",
        noXNumeric: true,
        dataFormatter: (data) => formatFlows(data),
        customSlicer: (data, xAxisDimension, yAxisDimension, valueDimension) =>
          sliceDriversData(
            data,
            xAxisDimension,
            yAxisDimension,
            valueDimension,
            "CO2ELECK"
          ),
        chartOptions: {
          yAxis: {
            plotLines: [
              {
                className: "highcharts-zero-axis",
                value: 0,
                zIndex: 1,
              },
            ],
          },
        },
      },
    },
  ],
});

const highlightsData = [
  {
    type: "text",
    value: {
      title: "Highlights",
      text: `
        <p>
        In 2022, the global CO<sub>2</sub> emissions from fuel combustion increased by 1.3%, surpassing the levels preceding the COVID-19 pandemic. Fossil fuels continued to represent 81% of the total energy supply (TES) globally, with oil comprising nearly 30%, followed by coal (28%) and natural gas (23%). Global emissions from fuel combustion were dominated by coal (45%), followed by oil (33%) and natural gas (22%).
        </p>
        <p>
        China and the United States together were responsible for 45% of the global fuel combustion emissions, followed by European Union, India, the Russian Federation and Japan. Explore the evolution of GHG emissions from fuel combustion across a range of countries in our interactive chart above.  Compare the shares of different products in the total energy supply and their respective contributions to fuel combustion emissions in the interactive chart below.
        </p>
      `,
    },
  },
  {
    type: "explorer",
    value: highlightsExplorerData,
  },
];

const fugitiveEmissionsData = [
  {
    type: "text",
    value: {
      title: "Fugitive emissions",
      text: `
        <p>
          Methane is estimated to be responsible for around 30% of the rise in global temperatures since the Industrial Revolution. Therefore swift, and sustained reductions in methane emissions are critical to limiting near-term global warming and improving air quality.
        </p>
        <p>
         Methane is the second largest greenhouse gas after CO<sub>2</sub>. The energy sector is responsible for nearly 40% of total methane emissions attributable to human activity, second only to agriculture. As highlighted by the <a href="https://www.iea.org/reports/global-methane-tracker-2023">IEA Global Methane Tracker 2024</a>, there is great potential in cutting the methane emissions from energy sector. It is estimated that the methane emissions from fossil fuel operations could be reduced around 70% with existing technology alone.
        </p>
      `,
    },
  },
  {
    type: "explorer",
    value: fugitiveEmissionsExplorerData,
  },
];

const socioeconomicIndicatorsData = [
  {
    type: "text",
    value: {
      title: "Socioeconomic indicators",
      text: `
        <p>
          Changes in the structural composition of the economy have significant implications for emissions. While developed countries have largely de-coupled economic growth from emissions, there is still a high correlation between wealth and GHG emissions in emerging economies. 
        </p>
        <p>
          Per capita emissions vary across countries and regions. Per capita emissions in China have almost tripled in the past twenty years, reaching values similar to those of the European Union (EU) in the early 2010s. India has almost doubled its emissions in the past two decades, but its per capita carbon intensity is still about one quarter of that of the EU. Africa has the lowest per capita emissions among all regions - around one fourteenth of the United States. Should India and Africa reach similar levels of per capita emissions as those of the EU, an additional 12 GtCO<sub>2</sub> (more than one third of current global levels) would be released into the atmosphere on an annual basis.
        </p>
        <p>
          Explore the evolution of these socioeconomic indicators across a range of countries and regions in our interactive chart below.
        </p>
      `,
    },
  },
  {
    type: "explorer",
    value: socioeconomicIndicatorsExplorerData,
  },
  {
    type: "text",
    value: {
      text: `
        <p>
          Among energy-related emissions, fuel combustion emissions account for the largest fraction. Understanding the fuels, sectors and macro-economic factors driving these emissions trends is pivotal to address the priorities needed to achieve energy and climate targets.
        </p>
        <p>
          CO<sub>2</sub> emissions are affected by the combined effect of the following drivers: population, per capita wealth, energy intensity of the economy and carbon intensity of the energy mix. Explore how these factors combined together have driven emissions across a range of countries and regions in our interactive chart above.
        </p>
        <p class="m-block__caption f-ui-3">
        The energy mix refers to the decomposition of CO2 emissions into four driving factors following the Kaya identity. For more information, please refer to the <a href="https://www.iea.org/data-and-statistics/data-product/greenhouse-gas-emissions-from-energy#documentation">IEA GHG Emissions from Energy documentation</a>.
        </p>
      `,
    },
  },
];

const sectoralAnalysisData = [
  {
    type: "text",
    value: {
      title: "Sectoral analysis",
      text: `
        <p>
        After allocating electricity and heat emissions to final sectors, industry continued to be the largest emitting sector in 2022, contributing to nearly 38% of global fuel combustion emissions in 2022. Emissions from the transport sector accounted for 24% of global emissions, while buildings emissions represented 26% of global emissions. Explore the CO<sub>2</sub> emissions from fuel combustion across sectors and a range of countries and regions in our interactive chart below. 
        </p>
      `,
    },
  },
  {
    type: "explorer",
    value: sectoralAnalysisExplorerData,
  },
];

const powerGenerationData = [
  {
    type: "text",
    value: {
      title: "Power generation",
      text: `
        <p>
          Despite global efforts in decarbonizing the power sector, in 2022 electricity and heat generation were responsible for nearly 44% of global CO<sub>2</sub> emissions from fuel combustion, with coal plants emitting around 73% of the associated emissions. 
        </p>
        <p>
        CO<sub>2</sub> emissions from electricity generation result from the combined effect of the following drivers: electricity output, generation efficiency, share of fossil in total generation, and carbon intensity of fossil generation. Explore how these factors combined together have affected emissions across a range of countries and regions in our interactive charts below.
        </p>
      `,
    },
  },
  {
    type: "explorer",
    value: powerGenerationExplorerData,
  },
];

export {
  highlightsData,
  fugitiveEmissionsData,
  socioeconomicIndicatorsData,
  sectoralAnalysisData,
  powerGenerationData,
};
